import { INLINE_HELP_VIEWED } from '../../constants';

export const inlineHelpViewed = helpId => ({
  type: INLINE_HELP_VIEWED,
  metrics: { helpId }
});
